const ENABLE_STRIPE_DEFAULT_YAML_VALUE = (email) => `enableStripe:
  hcpEmail: ${email || "haileyesuszemed@gmail.com"}
  enabled: true
  stripeAccountId: acct_1IrByE2QuLgYcgRu
  status: Instant Payouts Enabled`;

export { ENABLE_STRIPE_DEFAULT_YAML_VALUE };
